const STYLES = {
  "A+": "text-emerald-300 bg-emerald-500/15 border-emerald-500/40",
  A: "text-blue-300 bg-blue-500/15 border-blue-500/35",
  B: "text-zinc-400 bg-zinc-700/40 border-zinc-600/40",
};

export const GradeBadge = ({ grade, className = "" }) => {
  if (!grade) return null;
  return (
    <span
      data-testid={`grade-${grade}`}
      title={grade === "A+" ? "A+ — premium setup (catalyst + FVG at level, trend-aligned)" : grade === "A" ? "A — catalyst at a key level, trend-aligned" : "B — meets confluence, no strong catalyst"}
      className={`px-1 py-[1px] text-[9px] font-bold rounded-sm border leading-none ${STYLES[grade] || STYLES.B} ${className}`}
    >
      {grade}
    </span>
  );
};
